export default __webpack_public_path__ + "static/media/Paycom.d32e67c3.svg";